module.exports = __webpack_public_path__ + "img/1.cda3790c.jpg";